import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "uc_cookie_consent";

export const CookieConsent = () => {
  const [choice, setChoice] = useState(() => localStorage.getItem(KEY));
  if (choice) return null;

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setChoice(value);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-[90] pointer-events-auto border-t border-amber-500/25 bg-[#0C0C0C]/97 backdrop-blur-md" data-testid="cookie-banner">
      <div className="max-w-6xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center gap-4">
        <Cookie size={18} className="text-amber-400 shrink-0"/>
        <p className="text-xs text-white/60 leading-relaxed flex-1">
          <span className="font-mono-uc text-[10px] uppercase tracking-widest text-amber-400/90">THE SOVEREIGN UMBRELLA COMMAND</span> uses one
          strictly-necessary session cookie for secure authentication — no advertising or cross-site tracking. Details in our{" "}
          <Link to="/privacy" className="text-amber-400 hover:underline">Privacy Policy</Link>.
        </p>
        <div className="flex gap-2 shrink-0">
          <button
            data-testid="cookie-accept-btn"
            onClick={() => decide("accepted")}
            className="font-mono-uc text-[10px] uppercase tracking-widest px-4 py-2 bg-amber-500 text-black hover:bg-amber-400 transition-colors"
          >
            Accept
          </button>
          <button
            data-testid="cookie-essential-btn"
            onClick={() => decide("essential_only")}
            className="font-mono-uc text-[10px] uppercase tracking-widest px-4 py-2 border border-white/15 text-white/60 hover:bg-white/5 transition-colors"
          >
            Essential Only
          </button>
        </div>
      </div>
    </div>
  );
};
